import React from 'react'
import { Link } from 'react-router-dom'
import { appDevelopmentTypes } from './appDevelopmentTypeContent'

const cloudinaryImageUrl = (image, width) => {
  const source = new URL(image, "https://metatech-official.com").href
  const height = Math.round(width * 0.75)

  return `https://res.cloudinary.com/l7pafu4a/image/fetch/f_webp/q_60/w_${width}/h_${height}/c_fill/${source}`
}

const AppDevelopmentTypes = ({ eyebrow, heading, intro }) => (
  <section className="app-development-types py-5" aria-labelledby="app-development-types-heading">
    <div className="container">
      <div className="text-center mb-4">
        <h2 className="h5 fw-bold mb-3" style={{ color: '#6565ff' }}>
          {eyebrow || 'INDUSTRY SOLUTIONS'}
        </h2>
        <h2 id="app-development-types-heading" className="display-5 fw-bold text-light">
          {heading || 'Types Of App Development We Offer'}
        </h2>
        <p className="lead text-light text-opacity-75 mx-auto" style={{ maxWidth: 820 }}>
          {intro || 'Explore focused mobile products designed around the workflows, integrations, trust requirements, and growth model of your industry.'}
        </p>
      </div>

      <div className="row">
        {appDevelopmentTypes.map((type) => (
          <div key={type.slug} className="col-lg-3 col-md-6 col-12 my-2">
            <Link
              to={type.slug+'/'}
              className="text-decoration-none"
              onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' })}
              aria-label={`Learn about ${type.title}`}
            >
              <article
                className="card app-development-type-card h-100 overflow-hidden rounded-4 text-light"
                style={{ backgroundColor: '#0f0f12', border: '1px solid rgba(101, 101, 255, .55)' }}
              >
                <div className="app-development-type-card-image">
                  <img
                    src={cloudinaryImageUrl(type.image, 720)}
                    srcSet={[
                      `${cloudinaryImageUrl(type.image, 360)} 360w`,
                      `${cloudinaryImageUrl(type.image, 540)} 540w`,
                      `${cloudinaryImageUrl(type.image, 720)} 720w`
                    ].join(', ')}
                    sizes="(max-width: 767px) calc(100vw - 24px), (max-width: 1199px) calc(50vw - 24px), calc(25vw - 24px)"
                    width="720"
                    height="540"
                    className="w-100 h-100"
                    alt={`${type.title} services`}
                    loading="lazy"
                  />
                </div>
                <div className="card-body d-flex flex-column p-4">
                  <h3 className="h5 fw-bold">{type.title}</h3>
                  <p className="text-light text-opacity-75 mb-4">{type.summary}</p>
                  <span className="mt-auto" style={{ color: '#8f8fff' }}>
                    Explore service <i className="fa fa-arrow-right ms-2" aria-hidden="true"></i>
                  </span>
                </div>
              </article>
            </Link>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default AppDevelopmentTypes
